import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "./ContextProvider";

const PrivateRoute = ({children}) => {
    //const token = localStorage.getItem('ACCESS_TOKEN');
    //return user?<Outlet/> : <Navigate to="/login" />;
    const {user} = useStateContext();
    if (!user){
        return <Navigate to ="/login"/>;
    }

    return children;
};

export default PrivateRoute;